module.exports = __webpack_public_path__ + "img/travel-by-destination.e107097c.jpg";